export const EMAIL = 1
export const SMS = 2
export const POPUP = 3
export const NOTIFICATION = 4
export const OPERA_MINI_SPEED_DIAL = 6
export const MOBILE_PUSH_NOTIFICATION = 7
export const TELEGRAM = 9
export const TELEGRAM_CHARACTER_LIMIT = 4096
export const BONUS_ICON_KEY = 'bonus'
export const templateTypeMap = {
  [EMAIL]: 'Email',
  [SMS]: 'Sms',
  [POPUP]: 'In-App',
  [NOTIFICATION]: 'In-App',
  [OPERA_MINI_SPEED_DIAL]: 'Opera Mini Speed Dial',
  [MOBILE_PUSH_NOTIFICATION]: 'Webpush Mobile Notification',
  [TELEGRAM]: 'Telegram',
}

export enum ApiTemplateTypeEnum {
  EMAIL = 1,
  SMS = 2,
  POPUP = 3,
  NOTIFICATION = 4,
  OPERA_MINI_SPEED_DIAL = 6,
  MOBILE_PUSH_NOTIFICATION = 7,
  TELEGRAM = 9,
}

export const templateTypeTrackingNameMap: Record<number, string> = {
  [EMAIL]: 'emails',
  [SMS]: 'sms',
  [POPUP]: 'popup',
  [NOTIFICATION]: 'notification',
  [OPERA_MINI_SPEED_DIAL]: 'opera speed dial',
  [MOBILE_PUSH_NOTIFICATION]: 'mobile push notification',
  [TELEGRAM]: 'telegram',
}
